module.exports = __webpack_public_path__ + "static/media/rich6.66354484.JPG";